/**
 * Presentational: two-segment progress bar for Create Organization wizard.
 * Single Responsibility: render segments; active state from currentStep.
 */

import React from 'react';
import PropTypes from 'prop-types';

const SEGMENT_BASE_CLASS = 'h-2 w-24 rounded-full transition-colors';
const SEGMENT_ACTIVE_CLASS = 'bg-[#61b8e7]';
const SEGMENT_INACTIVE_CLASS = 'bg-[#d9d9d9]';

function getSegmentClassName(isActive) {
  return `${SEGMENT_BASE_CLASS} ${isActive ? SEGMENT_ACTIVE_CLASS : SEGMENT_INACTIVE_CLASS}`;
}

export function ProgressBar({ currentStep, totalSteps = 2 }) {
  return (
    <div className="mb-8 flex justify-center gap-2">
      {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
        <div
          key={step}
          className={getSegmentClassName(currentStep >= step)}
          aria-hidden="true"
        />
      ))}
    </div>
  );
}

ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number,
};
